import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface EntityDirectoryPageProps {
  sx?: BoxProps['sx'];
  actions?: ReactNode;
  children: ReactNode;
  description: string;
  eyebrow?: string;
  gap?: BoxProps['gap'];
  headerMinH?: BoxProps['minH'];
  headingLineHeight?: BoxProps['lineHeight'];
  headingSize?: BoxProps['fontSize'];
  maxW?: BoxProps['maxW'];
  minH?: BoxProps['minH'];
  pb?: BoxProps['pb'];
  px?: BoxProps['px'];
  py?: BoxProps['py'];
  title: string;
  titleTextTransform?: BoxProps['textTransform'];
}

export function EntityDirectoryPage({
  sx,
  actions,
  children,
  description,
  eyebrow,
  gap = 5,
  headerMinH,
  headingLineHeight = { base: 10, lg: '42px' },
  headingSize = { base: '3xl', lg: '40px' },
  maxW = '1800px',
  minH = 'calc(100dvh - 2rem)',
  pb,
  px = { base: 4, lg: 10 },
  py = { base: 6, lg: 8 },
  title,
  titleTextTransform,
}: EntityDirectoryPageProps) {
  return (
    <Box
      sx={sx}
      bg="entityDirectory.canvas"
      color="entityDirectory.text"
      minH={minH}
      px={px}
      py={py}
      pb={pb}
    >
      <Flex direction="column" gap={gap} maxW={maxW} mx="auto" w="full">
        <Flex
          align={{ base: 'stretch', md: 'start' }}
          direction={{ base: 'column', md: 'row' }}
          gap={3}
          justify="space-between"
          minH={headerMinH}
        >
          <Flex direction="column" gap={1}>
            {eyebrow && (
              <Text
                color="entityDirectory.mutedText"
                fontFamily="instrumentSans"
                fontSize="11px"
                fontWeight="bold"
                letterSpacing="0.16em"
                textTransform="uppercase"
              >
                {eyebrow}
              </Text>
            )}
            <Text
              color="entityDirectory.text"
              fontFamily="barlow"
              fontSize={headingSize}
              fontWeight="bold"
              letterSpacing="-0.025em"
              lineHeight={headingLineHeight}
              textTransform={titleTextTransform}
            >
              {title}
            </Text>
            <Text color="entityDirectory.mutedText" fontSize="13px">
              {description}
            </Text>
          </Flex>
          {actions}
        </Flex>
        {children}
      </Flex>
    </Box>
  );
}
